import { PlatformVersionInfo } from '../interfaces/common';
import date from 'date-and-time';

export const versionParser = (platformVersion: string): PlatformVersionInfo => {
  const platformVersionInfo = platformVersion.split('.');
  return {
    fullVersion: parseFloat(platformVersion),
    majorVersion: parseInt(platformVersionInfo[0]),
    minorVersion: parseInt(platformVersionInfo[1]),
    patchVersion: parseInt(platformVersionInfo[2] || '0'),
  };
};

export const convertDate = (selectedDate: string) => {
  if (!selectedDate) {
    return '';
  }
  return date.format(new Date(selectedDate), 'DD MMM YYYY HH:mm:ss');
};

export const getMaskedKey = (token: string = '', maxLength: number) => {
  let tokenLength = token?.length;
  if (maxLength && maxLength < tokenLength) {
    tokenLength = maxLength;
  }
  return new Array(tokenLength).fill('*').join('');
};

export const platformVersionCheck = (
  minMajorVersion: number,
  minMinorVersion: number,
  minPatchVersion: number,
  majorVersion?: number,
  minorVersion?: number,
  patchVersion?: number,
) => {
  const majorVersionEqual = majorVersion && majorVersion === minMajorVersion;
  const minorVersionEqual = minorVersion && minorVersion === minMinorVersion;

  const majorVersionCheck = majorVersion && majorVersion > minMajorVersion;
  const minorVersionCheck = majorVersionEqual && minorVersion && minorVersion > minMinorVersion;
  let patchVersionCheck = majorVersionEqual && minorVersionEqual && patchVersion && patchVersion >= minPatchVersion;
  patchVersionCheck = patchVersionCheck === 0 && patchVersion === minPatchVersion ? true : patchVersionCheck;
  const validVersion = patchVersionCheck || majorVersionCheck || minorVersionCheck;

  return validVersion;
};
